import React from "react"

import PropTypes from "prop-types"

import * as styles from "./form-state.module.scss"

const FormState = ({ children, condition, error, className, flex }) => (
  <div
    className={`form-screen ${className} ${styles.state} ${
      error ? styles.state__error : ""
    }  ${condition ? styles.state__show : styles.state__hide} ${
      flex ? styles.state__flex : ""
    }`}
  >
    {children}
  </div>
)

export default FormState

FormState.propTypes = {
  children: PropTypes.node.isRequired,
  condition: PropTypes.bool.isRequired,
  error: PropTypes.bool,
  className: PropTypes.string,
  flex: PropTypes.bool,
}

FormState.defaultProps = {
  error: false,
  className: "",
  flex: false,
}
